import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home"),
    meta: {
      title: "CSC Consultoria",
      metaTags: [
        {
          name: "description",
          content: "Página inicial da CSC Consultoria, Assessoria e Gestão.",
        },
        {
          property: "og:description",
          content: "Página inicial da CSC Consultoria, Assessoria e Gestão.",
        },
      ],
    },
  },
  {
    name: "events",
    path: "/eventos",
    component: () => import("@/views/EventsList"),
  },
  {
    name: "services",
    path: "/servicos",
    component: () => import("@/views/Services"),
    meta: {
      title: "Serviços - CSC",
      metaTags: [
        {
          name: "description",
          content:
            "A CSC oferece consultoria e assessoria em concursos públicos, processos seletivos e capacitações, além de promover a realizaçãode cursos. Saiba mais.",
        },
        {
          property: "og:description",
          content:
            "A CSC oferece consultoria e assessoria em concursos públicos, processos seletivos e capacitações, além de promover a realizaçãode cursos. Saiba mais.",
        },
      ],
    },
  },
  {
    name: "company",
    path: "/a-empresa",
    component: () => import("@/views/Company"),
    meta: {
      title: "A Empresa - CSC",
      metaTags: [
        {
          name: "description",
          content:
            "Saiba mais sobre nós: quem somos, nossa missão, nossa visão, nossos valores, área de atuação. Também conheça alguns de nossos clientes e parceiros.",
        },
        {
          property: "og:description",
          content:
            "Saiba mais sobre nós: quem somos, nossa missão, nossa visão, nossos valores, área de atuação. Também conheça alguns de nossos clientes e parceiros.",
        },
      ],
    },
  },
  {
    name: "who-we-are",
    path: "/quem-somos",
    component: () => import("@/views/WhoWeAre"),
    meta: {
      title: "Quem Somos - CSC",
      metaTags: [
        {
          name: "description",
          content:
            "Saiba mais sobre nós: quem somos, nossa missão, nossa visão, nossos valores, área de atuação. Também conheça alguns de nossos clientes e parceiros.",
        },
        {
          property: "og:description",
          content:
            "Saiba mais sobre nós: quem somos, nossa missão, nossa visão, nossos valores, área de atuação. Também conheça alguns de nossos clientes e parceiros.",
        },
      ],
    },
  },
  {
    name: "area-of-activity",
    path: "/area-de-atuacao",
    component: () => import("@/views/AreaOfActivity"),
    meta: {
      title: "Áreas de Atuação - CSC",
      metaTags: [
        {
          name: "description",
          content:
            "Saiba mais sobre o que fazemos! Trabalhamos nas áreas de: Concursos Públicos e Processos Seletivos; Assistência Social; Administração; Assistência Social; Conselho Tutelar; Educação; Recursos Humanos; Saúde.",
        },
        {
          property: "og:description",
          content:
            "Saiba mais sobre o que fazemos! Trabalhamos nas áreas de: Concursos Públicos e Processos Seletivos; Assistência Social; Administração; Assistência Social; Conselho Tutelar; Educação; Recursos Humanos; Saúde.",
        },
      ],
    },
  },
  {
    name: "trainings",
    path: "/treinamentos-e-desenvolvimento-profissional",
    component: () => import("@/views/Trainings"),
    meta: {
      title: "Treinamentos - CSC",
      metaTags: [
        {
          name: "description",
          content:
            "Confira nossos treinamentos e programas de desenvolvimento profissional! Realizamos Treinamentos nas áreas da: Administração, Assistência Social, Educação e Saúde, de acordo com o Levantamento de Necessidades.",
        },
        {
          property: "og:description",
          content:
            "Confira nossos treinamentos e programas de desenvolvimento profissional! Realizamos Treinamentos nas áreas da: Administração, Assistência Social, Educação e Saúde, de acordo com o Levantamento de Necessidades.",
        },
      ],
    },
  },
  {
    name: "courses",
    path: "/cursos-e-desenvolvimento",
    component: () => import("@/views/Courses"),
    meta: {
      title: "Cursos e Desenvolvimento - CSC",
      metaTags: [
        {
          name: "description",
          content:
            "Oferecemos cursos em diversas áreas do conhecimento, abrangendo desde habilidades técnicas até habilidades comportamentais, personalizados de acordo com suas necessidades.",
        },
        {
          property: "og:description",
          content:
            "Oferecemos cursos em diversas áreas do conhecimento, abrangendo desde habilidades técnicas até habilidades comportamentais, personalizados de acordo com suas necessidades.",
        },
      ],
    },
  },
  {
    name: "privacy-policy",
    path: "/politica-de-privacidade",
    component: () => import("@/views/PrivacyPolicy"),
    meta: {
      title: "Política de Privacidade - CSC",
      metaTags: [
        {
          name: "description",
          content:
            "Leia nossa política de privacidade e uso de dados pessoais.",
        },
        {
          property: "og:description",
          content:
            "Leia nossa política de privacidade e uso de dados pessoais.",
        },
      ],
    },
  },
  {
    name: "contact",
    path: "/contato",
    component: () => import("@/views/Contact"),
    meta: {
      title: "Contato - CSC",
      metaTags: [
        {
          name: "description",
          content:
            "Entre em contato conosco através deste formulário. Retornaremos em breve!",
        },
        {
          property: "og:description",
          content:
            "Entre em contato conosco através deste formulário. Retornaremos em breve!",
        },
      ],
    },
  },
  {
    name: "404",
    path: "*",
    component: () => import("@/views/404"),
    meta: {
      title: "Página Não Encontrada - CSC",
      metaTags: [
        {
          name: "description",
          content: "A página que você está procurando não foi encontrada.",
        },
        {
          property: "og:description",
          content: "A página que você está procurando não foi encontrada.",
        },
      ],
    },
  },
];

const router = new VueRouter({
  routes: routes,
  mode: "history",
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  document.title = nearestWithTitle
    ? nearestWithTitle.meta.title
    : "CSC Consultoria";

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(
    document.querySelectorAll("[data-vue-router-controlled]")
  ).map((el) => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) {
    return next();
  }

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

export default router;
